<template>
  <v-dialog :value="true" max-width="500" persistent @click:outside="close">
    <v-card>
      <v-card-title>
        <span class="headline">Scaneaza cod QR</span>
      </v-card-title>

      <v-card-text>
        <video ref="video" style="width: 100%" autoplay playsinline muted></video>
        <canvas ref="canvas" style="display: none"></canvas>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Anuleaza</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import jsQR from 'jsqr';

export default {
  name: 'QrScannerDialog',
  data() {
    return {
      stream: null,
      animationFrameId: null,
    };
  },
  async mounted() {
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
      });
      this.$refs.video.srcObject = this.stream;
      await this.$refs.video.play();
      this.scanFrame();
    } catch (e) {
      this.$emit('error', 'Nu s-a putut accesa camera.');
    }
  },
  beforeDestroy() {
    this.stopCamera();
  },
  methods: {
    scanFrame() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;

      if (video.readyState === video.HAVE_ENOUGH_DATA) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height);

        if (code) {
          this.stopCamera();
          this.$emit('detected', { binaryData: code.binaryData });
          return;
        }
      }

      this.animationFrameId = requestAnimationFrame(this.scanFrame);
    },
    stopCamera() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }
    },
    close() {
      this.stopCamera();
      this.$emit('close');
    },
  },
};
</script>

<style></style>
